import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

import { config } from "../../lib/envConfig";
import { get } from "../../axiosUtils/appUtils";

import Box from "@mui/material/Box";
import { Typography, CircularProgress, Checkbox } from "@mui/material";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import ConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import Toast from "../../components/Toast/Toast";

import { DEV_APP_URL, PROD_APP_URL, QA_APP_URL } from "../../lib/constant";
import Spinner from "../../components/Spinner/Spinner";

const BulkRenameFields = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [adminData, setAdminData] = useState([]);
  const [adminCurrentValues, setAdminCurrentValues] = useState([]);
  const [adminNewValues, setAdminNewValues] = useState([]);
  const [fragranceData, setFragranceData] = useState([]);
  const [getValuesLoading, setGetValuesLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("success");
  const [isLoading, setIsLoading] = useState(false);

  const { accounts } = useMsal();
  const baseUrl = `${config.VITE_API_URL}`;

  const [dropdownValues, setDropdownValues] = useState({
    field: "",
    currentValue: "",
    newValue: [],
  });
  const getAdminFieldsBulkDetails = async () => {
    const url = `/getAdminFieldsBulk?code=${code}&library_id=1&user_email=${userEmail}`;

    get(url)
      .then((response) => {
        const data = response?.data?.data;

        setAdminData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAdminFieldsBulkDetails();
  }, []);

  const userEmail = accounts.length > 0 ? accounts[0].username : "Guest";
  const code = config?.VITE_FUNC_KEY_CODE;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDropdownValues((prev) => ({
      ...prev,
      [name]: value,
    }));


    if(event.target.name === "field") {
       handleGetValues(event.target.value);
       setIsLoading(true);

       setDropdownValues((prev) => ({
         ...prev,
         currentValue: "",
         newValue: [],
       }));
    }
  };

  // Function to handle the field submission
  const handleGetValues = (fieldValue) => {
    if (getValuesLoading) return;

    setGetValuesLoading(true);
    const url = `/getAdminFieldsCurrentValueBulk?code=${code}&library_id=1&user_email=${userEmail}&field=${fieldValue}`;

    get(url)
      .then((response) => {
        const data = response?.data?.data;
        setAdminCurrentValues(data[0].CurrentValue);
        setAdminNewValues(data[0].NewValue);
        setIsSubmitting(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setGetValuesLoading(false);
      });
  };

  // Function to handle the submit action
  const handleSubmit = () => {
     if (submitLoading) return;
     setSubmitLoading(true);
    const url = `/getBulkProductsFieldsDataImpact?code=${code}&library_id=1&user_email=${userEmail}&titleName=${encodeURIComponent(dropdownValues?.field)}&existingValue=${encodeURIComponent(dropdownValues?.currentValue)}&newValue=${encodeURIComponent(dropdownValues?.newValue)}`;

    get(url)
      .then((response) => {
        const data = response?.data?.data;
        setFragranceData(data);
        setOpenDialog(true);
      })
      .catch((error) => {
        console.log(error);
      }) .finally(() => {
        setSubmitLoading(false);
      });
  };

const resetForm = () => {
  setDropdownValues({
    field: "",
    currentValue: "",
    newValue: [],
  });
  setAdminCurrentValues([]);
  setAdminNewValues([]);
  setFragranceData([]);
  setIsSubmitting(false);
};

  // Function to handle the save action in the dialog
  const handleSaveDialog = async () => {
    setOpenDialog(false);

    let url = `${baseUrl}/updateBulkProductsFieldsData?code=${code}&library_id=1&user_email=${userEmail}`;

    const payload = {
      titleName: dropdownValues?.field,
      existingValue: dropdownValues?.currentValue,
      newValue: dropdownValues?.newValue,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      let errorMsg = "";
      if (!response.ok) {
        try {
          const errorBody = await response.json();
          errorMsg =
            errorBody?.message ||
            errorBody?.error ||
            `HTTP error! Status: ${response.status}`;
        } catch {
          errorMsg = `HTTP error! Status: ${response.status}`;
        }
        setToastMsg(errorMsg);
        setToastType("error");
        setToastOpen(true);
        throw new Error(errorMsg);
      }
      resetForm();
      setToastMsg("Fields renamed successfully!");
      setToastOpen(true);
    } catch (error) {
      setToastMsg(error.message);
      setToastType("error");
      setToastOpen(true);
      throw error;
    }
  };

  const [appUrl, setAppUrl] = useState("");

  useEffect(() => {
    if((config?.VITE_API_URL)?.includes("dev-api")){
     setAppUrl(DEV_APP_URL);
    }else if((config?.VITE_API_URL)?.includes("qa-api")){
      setAppUrl(QA_APP_URL);
    }else if((config?.VITE_API_URL)?.includes("api")){
      setAppUrl(PROD_APP_URL);
    }else {
      setAppUrl(DEV_APP_URL);
    }
  }, [config]);

  return (
    <>
      <Box>
        <Typography variant="h5" gutterBottom>
          Rename Fragrance Fields
        </Typography>
        <Typography variant="body1">
          This page allows you to rename fragrance fields. You can select a
          field from the list and provide a new name for it.
        </Typography>
      </Box>

      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, padding: "10px" }}
      >
        <FormControl sx={{ width: "250px", position: "relative" }}>
          <InputLabel>Field</InputLabel>
          <Select
            value={dropdownValues.field}
            label="Field"
            name="field"
            onChange={handleChange}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  zIndex: 1300,
                },
              },
              disablePortal: true,
            }}
          >
            {adminData?.map((item, index) => {
              return (
                <MenuItem key={index} value={item.Subcategory}>
                  {item.Subcategory}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        {/* <Button
          variant="contained"
          sx={{
            width: "auto",
            height: "55px",
            fontSize: "12px",
          }}
          onClick={handleGetValues}
          disabled={dropdownValues.field?.length === 0}
        >
          {getValuesLoading ? (
            <CircularProgress
              size={24}
              sx={{
                color: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          ) : (
            "Get Values"
          )}
        </Button> */}
      </Box>

      <Box pt={3}>
        <Typography variant="body1">
          Please select a field to rename and provide the new value.
        </Typography>
      </Box>
      
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, padding: "10px" }}
      >
        <FormControl sx={{ width: "250px", position: "relative" }}>
          <InputLabel>Current Value</InputLabel>
          <Select
            value={dropdownValues.currentValue}
            label="Current Value"
            name="currentValue"
            onChange={handleChange}
            disabled={!isSubmitting || isLoading}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  zIndex: 1300,
                },
              },
              disablePortal: true,
            }}
          >
            {adminCurrentValues?.map((item, index) => {
              return (
                <MenuItem key={index} value={item.Name}>
                  {item.Name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ width: "250px", position: "relative" }}>
          <InputLabel>New Value</InputLabel>
          <Select
            value={dropdownValues.newValue}
            label="New Value"
            name="newValue"
            onChange={handleChange}
            multiple
            renderValue={(selected) => selected.join(', ')}
            disabled={!isSubmitting || isLoading}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  zIndex: 1300,
                },
              },
              disablePortal: true,
            }}
          >
            {adminNewValues?.map((item, index) => {
              return (
                <MenuItem key={index} value={item.Name}>
                  <Checkbox checked={dropdownValues.newValue.includes(item.Name)} /> {item.Name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          disabled={!dropdownValues?.currentValue || !dropdownValues?.newValue}
          sx={{
            width: "auto",
            height: "55px",

            fontSize: "12px",
          }}
          onClick={handleSubmit}
        >
         {submitLoading ? (
            <CircularProgress
              size={24}
              sx={{
                color: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          ) : (
            "Submit"
          )}
        </Button>
      </Box>
      {isLoading && <Spinner />}
      <ConfirmationDialog
        open={openDialog}
        handleClose={() => { resetForm(); setOpenDialog(false); }}
        saveData={handleSaveDialog}
        dialogData={{
          dialogTitle: "Warning!",
          dialogText: `This action will impact <b> ${fragranceData || 0}</b> fragrance cards!!<br/>Are you sure you want to proceed?`,
          submitButtonText: "Save"
        }}
      />
      <Toast
        open={toastOpen}
        toastMsg={toastMsg}
        severity={toastType}
        handleClose={() => setToastOpen(false)}
      />
    </>
  );
};

export default BulkRenameFields;
